import React from 'react';
import AppPaths from '../../AppPaths';
import { Redirect, useLocation } from 'react-router-dom';

export default function Home() {
  const location = useLocation();

  return <Redirect to={{ pathname: AppPaths.ProductListingPage, search: location.search }} />;
}
